// Node and mark types the static renderer knows how to render faithfully.
// Anything outside these sets (e.g. `message` embeds, tables, code blocks)
// forces a fallback to the full editor, keeping rendering correct by default.
export const SUPPORTED_NODE_TYPES: ReadonlySet<string> = new Set([
  "paragraph",
  "text",
  "hardBreak",
  "blockquote",
  "bulletList",
  "orderedList",
  "listItem",
  "mention",
  "entity",
]);

export const SUPPORTED_MARK_TYPES: ReadonlySet<string> = new Set([
  "bold",
  "italic",
  "strike",
  "underline",
  "link",
  "highlight",
]);
